import { LogDecorator } from '@tenryu/log-decorator';
import { useCallback, useEffect } from 'react';
import { LabOrderInfo } from './lab-order-info';
import { StoreInfoConfig } from './store-info-config';
import { SurrogateOrderModeConfig } from './surrogate-order-mode-config';
import './system-config.scss';
import { ShopConfig } from './shop-config';
import { PrintShopMetaSetting } from '../../../../api/front/system-config/api-meta-shop';
import { Button } from '../../../ui/button/button';
import settingIcon from '../../../../assets/img/icon/setting_white.svg';
import { useAppDispatch } from '../../../../app/hooks';
import { dialogActions } from '../../../dialog/slice/dialog-slice';
import { PrintSetting } from './print/print-setting-dialog';

type SystemConfigProps = {
  shopCode: string,
  // - 店舗コードの取得ハンドラ -
  getShopCode: (code: string) => void,
  isNeedAgreement: boolean,
  // - 校正承認の有無取得ハンドラ -
  getIsNeedAgreement: (state: boolean) => void,
  surrogateOrderMode: boolean | null,
  // - 代理発注モードの有無取得ハンドラ -
  getSurrogateOrderMode: (state: boolean) => void,
  // - スタッフ管理機能の有無 -
  isStaffManagement: boolean,
  getIsStaffManagement: (state: boolean) => void,
  // - スタッフログインの有無 -
  isStaffLogin: boolean,
  print: {
    request: PrintShopMetaSetting,
    setRequest: (v: PrintShopMetaSetting) => void,
  }
};
export const SystemConfig = (props: SystemConfigProps) => {
  const {
    shopCode,
    getShopCode,
    isNeedAgreement,
    getIsNeedAgreement,
    surrogateOrderMode,
    getSurrogateOrderMode,
    isStaffManagement,
    // スタッフ管理機能の有無取得ハンドラ
    // 2023/07/19時点: スタッフ管理機能をON→OFFにできない仕様のため未使用。
    getIsStaffManagement,
    isStaffLogin,
    print,
  } = props;
  const dispatch = useAppDispatch();
  const handlerClickPrintSetting = useCallback(() => {
    dispatch(dialogActions.push({
      title: 'まとめてプリント詳細設定',
      element: <PrintSetting {...print} />,
      className: 'print_setting_edit'
    }))
  }, [dispatch, print]);
  // - Effect -
  useEffect(() => {
    // -- ログまとめ --
    LogDecorator.group('<magenta>システム設定</magenta>');
    return () => LogDecorator.groupEnd();
  });
  return (
    <div className="system_config">
      <StoreInfoConfig />

      {/* <LabInfoConfig /> */}

      <LabOrderInfo
        isNeedAgreement={isNeedAgreement}
        getIsNeedAgreement={getIsNeedAgreement}
      />
      <div className="surrogate_order_mode_config mt_2rem">
        <div className="bottom_border_header">
          まとめてプリント設定
        </div>
        <div className="top_label_ui">
          <div className="radio_buttons_box">
            <Button
              label="詳細設定"
              onClick={handlerClickPrintSetting}
              icon={
                <img src={settingIcon} style={{ width: '20px', height: '20px' }}alt=""/>
              }
            />
          </div>
        </div>
      </div>

      {/* <OrderInfoConfig />

      <LogInfoConfig />

      <ReceptionSlipOutputConfig />

      <ProcessManageInfoConfig />

      <PackageInfoConfig /> */}

      {
        (surrogateOrderMode !== null) ?
          <SurrogateOrderModeConfig
            surrogateOrderMode={surrogateOrderMode}
            getSurrogateOrderMode={getSurrogateOrderMode}
          />
          : <></>
      }
      {!isStaffLogin &&(
        <ShopConfig isStaffMng={isStaffManagement} />
        )
      }
    </div>
  );
};
